const einProgram = {
  einProgram: {
    pageHeader: 'Lead ed Enphase Installer Network',
    title: 'Iscrizione EIN accettata',
    overview: 'Panoramica',
    noCompany: 'Nessuna azienda trovata',
    goToDashboard: 'Vai al dashboard',
    messageFromCeo: 'Leggi il messaggio del nostro CEO',
    companyProfileLink: 'Aggiorna il tuo profilo aziendale',
    serviceAreasLink: 'Selezionare le tue aree dei servizi',
    leadsPreferencesLink: 'Imposta le tue preferenze lead',
    reviewInstallerLink: 'Rivedi i termini e le condizioni per gli installatori',
    open: 'aperto',
    video: 'video',
    selected: 'selezionato',
    learnMore: 'Maggiori informazioni',
    completed: 'Completato',
    pending: 'In corso',
    optInDisabledHeader: 'Programma EIN (in arrivo)',
    optInDisabledDescription:
      "L'Enphase Installer Network (EIN) è un ottimo modo per farti trovare dai proprietari di case! I proprietari di casa si affidano ad EIN per identificare gli installatori che assicurano elevati standard di assistenza clienti e qualità del sistema usando prodotti Enphase. In qualità di membro EIN hai accesso a diversi vantaggi che ti aiuteranno a vendere, a installare e a realizzare di più.",
    einTier: 'Il tuo livello Enphase Installer Network(EIN): ',
    none: 'Nessuna',
    viewBenefits: 'Per visualizzare i tuoi vantaggi EIN, fai clic ',
    here: 'qui',
    anyQuestions: ' Se hai domande sulla tua iscrizione EIN, puoi contattare il tuo',
    enphaseAccountRepresentative: ' Rappresentazione account Enphase.',
    learnReceivingLeads: 'Scopri come riceverai lead dalla piattaforma digitale Enphase ',
    benefitsOfEIN: "Visualizza i vantaggi dell'EIN ",
    contactEnphaseRepresentative:
      ". Contatta il tuo rappresentante Enphase Account per saperne di più sull'EIN e l'Enphase Leads Program.",
    congratulations: 'Congratulazioni!',
    whichInstaller: 'Installatore %{tierName}. ',
    invitationText1: 'Sei stato invitato a partecipare al programma Enphase Installer Network(EIN) come ',
    invitationText2:
      "L'Enphase Installer Network (EIN) è la nostra rete fidata di installatori che offrono ai proprietari di case un'esperienza eccezionale con l'uso dei prodotti Enphase. L'EIN è stata progettata per rafforzare il nostro rapporto con te e per accelerare la tua crescita. In qualità di membro EIN hai accesso a diversi vantaggi che ti aiuteranno a vendere, a installare e a realizzare di più. Esamina i vantaggi completi ",
    acceptInvitation: 'Per accettare il nostro invito:',
    acceptTerms: 'Accetto i termini e le condizioni',
    cellmodemCheck: 'Accetto i',
    cellmodemTeamcondition: ' termini e le condizioni ',
    cellmodemLinkTitle: 'del Estensione dati Mobile Connect',
    notEstablished: 'Non definiti.',
    contactEin: "Contatta il tuo rappresentante Enphase Account per saperne di più sull'EIN.",
    getFreeLeads: 'Per ottenere lead gratuiti, compila i seguenti passaggi:'
  }
};

export default einProgram;
